/** @format */

export namespace NsEmployeeWebExp {
  export interface IEnv {
    empExp: string;
    tms: string;
    floorplan: string;
    empExpUI: string;
    navLinks: INavLinks;
    platform: "ets" | "stratus";
    empExpStatic: string;
    parkingFloorPlan: string;
    appServices: IAppServicesLinks;
    wisSeatBooking: string;
    securityGuard: string;
    mealBooking: string;
  }

  export interface INavLinks {
    meetingRooms: string;
    vaccinationUpload: string;
    bookingHistory: string;
  }

  export interface IAppServicesLinks {
    booking: string;
  }

  export interface IUserInfo {
    buid: string;
    empGuid: string;
  }
}
